<template>
  <div class="home">
    <HomeTopCarousel />
    <HomeProductPromote />
    <HomeNews />
    <HomeVideo v-if="first_touch" />
    <HomeSocial />
  </div>
</template>

<script>
import HomeNews from "../components/Home/HomeNews/index";
import HomeTopCarousel from "../components/Home/HomeTopCarousel/index";
import HomeProductPromote from "../components/Home/HomeProductPromote/index";
import HomeVideo from "../components/Home/HomeVideo/index";
import HomeSocial from "../components/Home/HomeSocial/index";
export default {
  name: "Home",
  components: {
    HomeNews,
    HomeTopCarousel,
    HomeProductPromote,
    HomeSocial,
    HomeVideo,
  },
  data() {
    return {
      first_touch: false,
    };
  },
  mounted() {
    document.addEventListener("touchstart", () => {
      //使用者觸碰過網頁後才能啟用自動播放
      this.first_touch = true;
    });
    document.addEventListener("scroll", () => {
      //使用者觸碰過網頁後才能啟用自動播放
      this.first_touch = true;
    });
    window.prerenderReady = true;
  },
  watch: {
    $route() {
      this.first_touch = false;
    },
  },
  metaInfo() {
    return {
      title: "首頁｜銳仕技研｜Rerace Performance",
      meta: [
        {
          property: "og:description",
          content:
            "Rerace 鋭仕技研，起源於2018年。長年專注於開發高品質高性能的避震器內管套件產品，並針對不同需求的玩家進行相對應並且可調的產品開發，希望讓每個喜愛玩車的人都能擁有一支適合自己的避震系統產品研發設計由總經理親自操刀，致力於優化現有避震器構造及材料應用。製造皆由專業技師使用高精密度機器製造，製造過程不放過任何一點小細節。一切都是為了讓喜歡我們的消費者能在購買使用產品後能有物超所值的感受",
          vmid: "og:description",
        },
        {
          property: "twitter:description",
          content:
            "Rerace 鋭仕技研，起源於2018年。長年專注於開發高品質高性能的避震器內管套件產品，並針對不同需求的玩家進行相對應並且可調的產品開發，希望讓每個喜愛玩車的人都能擁有一支適合自己的避震系統產品研發設計由總經理親自操刀，致力於優化現有避震器構造及材料應用。製造皆由專業技師使用高精密度機器製造，製造過程不放過任何一點小細節。一切都是為了讓喜歡我們的消費者能在購買使用產品後能有物超所值的感受",
          vmid: "twitter:description",
        },
        {
          property: "description",
          content:
            "Rerace 鋭仕技研，起源於2018年。長年專注於開發高品質高性能的避震器內管套件產品，並針對不同需求的玩家進行相對應並且可調的產品開發，希望讓每個喜愛玩車的人都能擁有一支適合自己的避震系統產品研發設計由總經理親自操刀，致力於優化現有避震器構造及材料應用。製造皆由專業技師使用高精密度機器製造，製造過程不放過任何一點小細節。一切都是為了讓喜歡我們的消費者能在購買使用產品後能有物超所值的感受",
          vmid: "description",
        },
        {
          property: "og:image",
          content: "https://rerace.yongxin-design.com/img/share/index.jpg",
          vmid: "og:image",
        },
        {
          property: "apple-mobile-web-app-title",
          content: "首頁｜銳仕技研｜Rerace Performance",
          vmid: "apple-mobile-web-app-title",
        },
        {
          property: "application-name",
          content: "首頁｜銳仕技研｜Rerace Performance",
          vmid: "application-name",
        },
        {
          property: "og:site_name",
          content: "首頁｜銳仕技研｜Rerace Performance",
          vmid: "og:site_name",
        },
        {
          property: "og:type",
          content: "website",
          vmid: "og:type",
        },
        {
          property: "og:locale",
          content: "zh_tw",
          vmid: "og:locale",
        },
      ],
    };
  },
};
</script>
